import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import MobileTaskSize from '../MobileTaskSize';

const prices = {
  'Extra small': [
    '$28.50',
    '$30.00',
    '$31.50',
    '$34.50',
    '$39.00',
    '$45.00',
    '$52.50',
    '$67.50',
  ],
  'Small': [
    '$61.75',
    '$65.00',
    '$68.25',
    '$74.75',
    '$84.50',
    '$97.50',
    '$113.75',
    '$146.25',
  ],
  'Medium': [
    '$118.75',
    '$125.00',
    '$131.25',
    '$143.75',
    '$162.50',
    '$187.50',
    '$218.75',
    '$281.25',
  ],
  'Large': [
    '$228.00',
    '$240.00',
    '$252.00',
    '$276.00',
    '$312.00',
    '$360.00',
    '$420.00',
    '$540.00',
  ],
}

export default function Programming(props) {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [selectedSize, setSelectedSize] = useState('Small');
  const deadlines = [
    '14 days',
    '7 days',
    '5 days',
    '3 days',
    '48 hours',
    '24 hours',
    '8 hours',
    '4 hours',
  ];
  const renderedDeadline = deadlines.map(deadline => {
    return (
      <span key={deadline} className="table-column__cell">{deadline}</span>
    )
  })
  const renderedColumns = Object.entries(prices).map(col => {
    return (
      <div className="table-column" key={col[0]} data-service-type={col[0]}>
        <span className="table-column__label">{col[0]}</span>
        {col[1].map(item => <span key={item} className="table-column__cell">{item}</span>)}
      </div>
    )
  });

  const onResize = (e) => {
    setTimeout(() => {
      setWindowSize(e.target.innerWidth);
    }, 500);
  }

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);

  return (
    <Fragment>
      <MobileTaskSize
        setSelectedSize={setSelectedSize}
      />
      <div className="service-table" style={{
        gridTemplateColumns: `repeat(${Object.keys(prices).length + 1}, 1fr)`
      }}>
        <div className="table-column">
          <span className="table-column__label">&nbsp;</span>
          {renderedDeadline}
        </div>
        {windowSize > 1024 && renderedColumns}
        {windowSize < 1024 && (
          <div className="table-column">
            <span className="table-column__label">&nbsp;</span>
            {prices[selectedSize].map(item => {
              return (
                <span key={item} className="table-column__cell">{item}</span>
              );
            })}
          </div>
        )}
      </div>
    </Fragment>
  )
}
